import { Link } from "react-router-dom";
import "./DesignCard.css";
import { useTranslation } from "react-i18next";
import Chip from "@mui/material/Chip";

const DesignCard = ({
  designId,
  pinId,
  title,
  createdAt,
  thumbnail,
  likes,
  isAdmin,
  cityName,
  pinName,
  sortOrder,
  index
}) => {
  const state = { designId, pinId, title, createdAt, isAdmin, cityName, pinName, sortOrder, index };

  const { t } = useTranslation();

  const url = `/pin/${pinId}/design/${designId}`;
  const createdAtDate = new Date(createdAt);
  const day = createdAtDate.getDate();
  const month = createdAtDate.getMonth() + 1;
  const year = createdAtDate.getFullYear();
  const calendarIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
    >
      <path
        d="M0 8.92969C0 9.77969 0.65 10.4297 1.5 10.4297H8.5C9.35 10.4297 10 9.77969 10 8.92969V4.92969H0V8.92969ZM8.5 1.42969H7.5V0.929688C7.5 0.629687 7.3 0.429688 7 0.429688C6.7 0.429688 6.5 0.629687 6.5 0.929688V1.42969H3.5V0.929688C3.5 0.629687 3.3 0.429688 3 0.429688C2.7 0.429688 2.5 0.629687 2.5 0.929688V1.42969H1.5C0.65 1.42969 0 2.07969 0 2.92969V3.92969H10V2.92969C10 2.07969 9.35 1.42969 8.5 1.42969Z"
        fill="#06C067"
      />
    </svg>
  );
  const fullDateText = `${day}/${month}/${year}`;
  const votes = `${likes?.length || 0} Votes`;

  return (
    <div className="design_card_container">
      <Link to={url} state={state} style={{ textDecoration: "none", display: 'block' }}>
        <div className="design_image_wrapper">
          <img className="design_image" src={thumbnail} />
          <div style={topChipStyles}>
            <Chip
              sx={{
                "& .MuiChip-label": {
                  padding: '4px 12px'
                }
              }} 
              icon={calendarIcon}
              label={fullDateText}
              style={{
                backgroundColor: "#FFFFFF",
                color: "#000000",
                fontFamily: "Manrope",
                fontWeight: "400",
                paddingLeft: '7px',
                fontSize: '13px',
                fontWeight: '500',
                height: '25px'
              }}
            />
          </div>
          <div style={bottomChipStyles}>
            <Chip
              sx={{
                "& .MuiChip-label": {
                  padding: '4px 12px'
                }
              }} 
              label={votes}
              style={{
                backgroundColor: "#06C067",
                color: "#FFFFFF",
                fontFamily: "Manrope",
                fontWeight: "400",
                fontSize: '13px',
                fontWeight: '500',
                height: '25px'
              }}
            />
          </div>
        </div>
        <div className="label_design_wrapper">
          <p className="design_title">{title || t("noTitle")}</p>
          <button className="design_btn">See Design</button>
        </div>
      </Link>
    </div>
  );
};

export default DesignCard;

const topChipStyles = {
  position: "absolute",
  top: 18,
  left: 18,
  zIndex: 50,
  maxWidth: "110px",
  height: 20,
};

const bottomChipStyles = {
  position: "absolute",
  top: 50,
  left: 18,
  zIndex: 50,
  maxWidth: "110px",
  height: 20,
};
